import {ContractMethod, ConvenienceStoreInfo, ErrorMessagesBaseForContractInputExcludePaymentTerm, ErrorMessagesForPaymentMethodInput, MobileCarrierInfo, NewCreditCardInputInfo, PaymentInputDetail, PaymentInputDetailWithMethod} from '../../../../Props/ContractInputInfo'
import {MBMemberRadio} from '../../../Atoms/MBMemberRadio'
import {PAYMENT} from '../../../../../Common/Constants'
import {MBMemberError} from '../../../../Common/MBMemberError'
import React from 'react'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {NewCreditCardInputComponent} from '../../../Components/PaymentsRelations/InputContentBlocks/NewCreditCardInputComponent'
import {MobileCarrierInputComponent} from '../../../Components/PaymentsRelations/InputContentBlocks/MobileCarrierInputComponent'
import {ConvenienceStoreInputComponent} from '../../../Components/PaymentsRelations/InputContentBlocks/ConvenienceStoreInputComponent'

export type DisplayPaymentMethodsProps = {
  disabled: boolean
  paymentMethodList: ContractMethod[]
  paymentInputDetailWithMethod: PaymentInputDetailWithMethod
  errorMessages: ErrorMessagesBaseForContractInputExcludePaymentTerm
  onChangeSelectedMethod: (changeSelectedMethod: ContractMethod) => void
  onChangeInputDetailInfo: (changeInputDetailInfo: PaymentInputDetail) => void
}

export const SignupDisplayPaymentMethodsRadioList: React.VFC<DisplayPaymentMethodsProps> =
  (props) => {
    return (
      <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>} showFirstDivider showEndDivider>
        {props.paymentMethodList.map((paymentMethod, idx) => {
          const checked = props.paymentInputDetailWithMethod.method === paymentMethod

          return (
            <div key={`payment-method-${idx}`}>
              <MBMemberRadio
                id={`payment-${idx}`}
                name="payment"
                labelName={PAYMENT.METHODS_FOR_RADIO_LABEL[paymentMethod]}
                disabled={props.disabled}
                hasError={props.errorMessages.paymentInputMethodErrors.length > 0}
                onChange={(): void => {
                  props.onChangeSelectedMethod(paymentMethod)
                }}
                checked={checked}
                isBoldLabel
              />
              <DisplayInputDetailPaymentMethod
                paymentMethod={paymentMethod}
                paymentInputDetailWithMethod={props.paymentInputDetailWithMethod}
                errorMessages={props.errorMessages}
                onChangeInputDetailInfo={
                  (value: PaymentInputDetail): void => props.onChangeInputDetailInfo(value)
                }
              />
            </div>
          )
        })}
      </PIMStack>
    )
  }

export type DisplayInputDetailPaymentMethodForProps = {
  paymentMethod: ContractMethod
  paymentInputDetailWithMethod: PaymentInputDetailWithMethod
  errorMessages: ErrorMessagesForPaymentMethodInput
  onChangeInputDetailInfo: (changeInputDetailInfo: PaymentInputDetail) => void
}

const DisplayInputDetailPaymentMethod: React.VFC<DisplayInputDetailPaymentMethodForProps>
  = (props) => {
  if (props.paymentInputDetailWithMethod.method !== props.paymentMethod) {
    return <></>
  }

  switch (props.paymentInputDetailWithMethod.method) {
    case 'credit_card':
      return (
        <NewCreditCardInputComponent
          newCreditCardInputInfo={
            props.paymentInputDetailWithMethod.creditCard.newCreditCardInfo}
          errorMessages={props.errorMessages}
          onChangeInputDetailInfo={
            (value: NewCreditCardInputInfo): void =>
              props.onChangeInputDetailInfo({
                creditCard: {
                  creditCardType: 'newCard',
                  newCreditCardInfo: value,
                  myCreditCardInfo:
                  props.paymentInputDetailWithMethod.creditCard.myCreditCardInfo,
                },
                mobileCarrier: props.paymentInputDetailWithMethod.mobileCarrier,
                convenienceStore: props.paymentInputDetailWithMethod.convenienceStore,
              })
          }
        />
      )

    case 'mobile_carrier':
      return <MobileCarrierInputComponent
        mobileCarrierInputInfo={props.paymentInputDetailWithMethod.mobileCarrier}
        errorMessage={props.errorMessages}
        onChangeInputDetailInfo={
          (value: MobileCarrierInfo): void =>
            props.onChangeInputDetailInfo({
              creditCard: props.paymentInputDetailWithMethod.creditCard,
              mobileCarrier: value,
              convenienceStore: props.paymentInputDetailWithMethod.convenienceStore,
            })
        }
      />
    case 'convenience_store':
      return <ConvenienceStoreInputComponent
        convenienceStoreInputInfo={props.paymentInputDetailWithMethod.convenienceStore}
        errorMessage={props.errorMessages}
        onChangeInputDetailInfo={
          (value: ConvenienceStoreInfo): void =>
            props.onChangeInputDetailInfo({
              creditCard: props.paymentInputDetailWithMethod.creditCard,
              mobileCarrier: props.paymentInputDetailWithMethod.mobileCarrier,
              convenienceStore: value,
            })
        }
      />
    case 'none':
      return <></>

    default:
      throw new MBMemberError('SystemError')
  }
}
